var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observe } from "mobx";
import { observer } from "mobx-react";
import { Icon, Loader, WrapWithAnimate } from "sb-resp-ui";
// external components
import * as CMP from "./components";
import { ButtonModifiers, OddsModifiers } from "../../enums";
import { excludeLetters } from "../../helpers";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the YourbetMiniBetSlip component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
var YourbetMiniBetSlip = /** @class */ (function (_super) {
    __extends(YourbetMiniBetSlip, _super);
    function YourbetMiniBetSlip(props) {
        var _this = _super.call(this, props) || this;
        // setup dictionary
        _this.dict = _this.props.dict;
        // setup data provider
        _this.state = {
            dataProvider: _this.props.dataProvider
        };
        _this.stakeInput = React.createRef();
        _this.disposeStakeValue = observe(_this.state.dataProvider, "stakeValue", function (o) {
            if (_this.stakeInput.current) {
                _this.stakeInput.current.value = o.newValue;
            }
        });
        return _this;
    }
    YourbetMiniBetSlip.prototype.componentWillUnmount = function () {
        this.disposeStakeValue();
    };
    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    YourbetMiniBetSlip.prototype.renderSummary = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-yourbet__main-slide rj-yourbet__main-slide--center" },
            this.state.dataProvider.purchases.map(function (p) { return (_this.state.dataProvider.isAccepted &&
                React.createElement("div", { className: "rj-yourbet__selections", key: "ticket-" + p.id },
                    React.createElement(CMP.Summary, { txt_1: _this.dict.Stake, txt_2: p.stake || "", odds: p.odds || "", returnTxt: _this.dict.Return, returnValue: p.return || "", oddsModf: OddsModifiers.accepted }),
                    React.createElement(CMP.Market, { title: _this.dict.TicketNumber, market: p.id }))); }),
            !this.state.dataProvider.selectionsCount && React.createElement(CMP.EmptyMsg, { label: this.dict.EmtyMsg })));
    };
    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    YourbetMiniBetSlip.prototype.renderFooter = function () {
        var leftComponentStake = this.state.dataProvider.leftComponentStake;
        var leftComponentButton = this.state.dataProvider.leftComponentButton;
        var rightComp = this.state.dataProvider.rightComponent;
        var stakeType = this.props.stakeInputType || "number";
        return (React.createElement("div", { className: "rj-yourbet__section rj-yourbet__footer" },
            leftComponentButton ?
                React.createElement(CMP.Button, { modifier: leftComponentButton.modifier, handler: leftComponentButton.handler }, leftComponentButton.label)
                :
                    React.createElement("div", { className: "rj-yourbet__stake" },
                        React.createElement(CMP.Button, { modifier: ButtonModifiers.stake, handler: leftComponentStake.buttons.left.handler, disabled: leftComponentStake.buttons.left.disabled },
                            React.createElement(Icon, { i: "i-14 i-o-yourbet-minus" })),
                        React.createElement(CMP.StakeInput, { provider: this.state.dataProvider, handler: leftComponentStake.handler, inputHandler: excludeLetters, type: stakeType }),
                        React.createElement(CMP.Button, { modifier: ButtonModifiers.stake, handler: leftComponentStake.buttons.right.handler, disabled: leftComponentStake.buttons.right.disabled },
                            React.createElement(Icon, { i: "i-14 i-o-yourbet-plus" }))),
            React.createElement(CMP.Button, { modifier: rightComp.modifier, handler: rightComp.handler, disabled: rightComp.disabled }, rightComp.label)));
    };
    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    YourbetMiniBetSlip.prototype.render = function () {
        var _this = this;
        var hasSelections = this.state.dataProvider.selectionsCount && !this.state.dataProvider.isAccepted ? " rj-yourbet__main--has-selections" : "";
        // TODO Use a setting to enable or disable the slide down animation on mount>
        return React.createElement(WrapWithAnimate, { shouldWrap: true, animation: "slideDown", duration: 200, runOnMount: true },
            React.createElement("div", { className: "rj-yourbet" },
                this.state.dataProvider.purchases.map(function (p) { return (_this.state.dataProvider.messages(p.id).map(function (x, y) { return (React.createElement(CMP.Message, { key: x.id + "-" + y, modifier: x.modifier, label: x.label, type: x.type, handler: x.handler })); })); }),
                React.createElement("div", { className: "rj-yourbet__main" + hasSelections },
                    this.renderSummary(),
                    React.createElement("div", { className: "rj-yourbet__main-slide" },
                        React.createElement("div", { className: "rj-yourbet__selections" },
                            this.state.dataProvider.purchases.map(function (p) { return (_this.state.dataProvider.selectionsCount > 0 && /*!this.state.dataProvider.isAccepted &&*/
                                React.createElement(CMP.Summary, { key: p.id, txt_1: _this.state.dataProvider.selectionsCount, txt_2: _this.dict.SelectionLabel, odds: p.odds || "", returnTxt: _this.dict.Return, returnValue: p.return || "", oddsModf: p.oddsUpdated ? OddsModifiers.changed : OddsModifiers.default })); }),
                            React.createElement("div", { className: "rj-yourbet__selection-list", ref: function (x) { return _this.selections = x; } }, !this.state.dataProvider.isAccepted && this.state.dataProvider.provider.selections.map(function (sel, i) { return (React.createElement(WrapWithAnimate, { key: sel.id, shouldWrap: i > 1, animation: "scroll", container: _this.selections, axis: "x", runOnMount: true },
                                React.createElement(CMP.Market, { title: sel.name, market: sel.eventType, handler: function () { _this.state.dataProvider.removeSelection(sel.id); }, isSuspended: sel.suspended, suspendedTxt: sel.suspended ? _this.dict.Danger : "" }))); }))))),
                this.renderFooter(),
                this.state.dataProvider.isWaiting && React.createElement("div", { className: "rj-yourbet__loader" },
                    React.createElement(Loader, null))));
    };
    YourbetMiniBetSlip = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], YourbetMiniBetSlip);
    return YourbetMiniBetSlip;
}(React.Component));
export { YourbetMiniBetSlip };
//# sourceMappingURL=YourbetMiniBetSlip.js.map